import { INPUT_TYPE_TEXT } from './config';

export const CORE_INPUT_PROPS = {
  type: INPUT_TYPE_TEXT,
  value: undefined,
  options: null,
  label: null,
  title: null
};
